export enum Navbar {
    Resources = 'Resources'
}